.menu-toggle {
  width: 32px;
  border-radius: 6px;
  color: var(--grey-800);

  &:hover,
  &:focus {
    background-color: var(--blue-200);
    color: var(--blue-900);
  }

  &:active {
    background-color: var(--grey-100);
    color: var(--grey-850);
  }
}

.open-menu-toggle {
  background-color: var(--grey-100);
  color: var(--grey-850);
}

.menu-toggle-contents {
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 16px;
  }
}
